import { formatFieldName } from "./formatFieldName";
import { detectColumnType } from "./detectColumnType";

export function extractColumns(data = []) {

  if (!Array.isArray(data) || data.length === 0) return [];

  const hiddenPattern = /(^ID$|_ID$)/i;

  const keys = Object.keys(data[0]).filter(
    (key) => !hiddenPattern.test(key)
  );

  return keys.map((key) => {

    const values = data.map((r) => r[key]);

    const type = detectColumnType(key, values);

    return {
      key,
      label: formatFieldName(key),
      type,
      options:
        type === "enum"
          ? [...new Set(values)].filter(Boolean).slice(0, 20)
          : null,
    };

  });
}
